import { client } from "@api";
import { IRichmenu } from "@types";

export const getRichmenu = async (token: string) => {
  const { data }: { data: IRichmenu } = await client.get(
    `/api/apps/public/edb2f005-129c-4941-987a-cad5f7d1f1c0/richmenus/tokens/${token}`
  );
  return data;
};
